/**
 * HomeStatusStrip — smart-home-linja på kjøkkenskjermen (Wave 1, v1.1;
 * Stell_Kjokken-linja med lyspære i #160, ikke lenger et eget kort).
 *
 * Fills the home slot in IdleMode. Reads the
 * read-only Hue/Homey light tally from GET /api/smarthome/status via
 * useSmartHome.
 *
 * Graceful degradation (matches the backend's never-throw contract):
 *  - No provider configured, status loading, query error, or no lights → the
 *    warm placeholder "Hjem: alt rolig".
 *  - Lights configured & some on  → "{n} lys er på".
 *  - Lights configured & all off  → "Alt rolig hjemme".
 *
 * Originally a pure placeholder (Plan 01-14 Task 3); smart-home integration was
 * PROJECT.md Out-of-Scope until the v1.1 read-only tile landed.
 */
import { useTranslation } from 'react-i18next';
import { Icon } from '../../../components/primitives/Icon';
import { useSmartHome } from '../useSmartHome';

export function HomeStatusStrip() {
  const { t } = useTranslation();
  const { data } = useSmartHome();

  const lights = data?.configured ? data.lights : null;

  return (
    <div className="text-ink-2 flex items-center gap-2.5 text-body font-semibold">
      <Icon.Bulb size={20} className="shrink-0" />
      {/* Overskriften «Hjemme» står bare for skjermlesere; skissen har én linje. */}
      <span data-testid="home-title" className="sr-only">
        {t('dashboard.home.title')}
      </span>
      {lights ? (
        <p data-testid="home-live" className="m-0" data-lit={lights.on > 0 ? 'true' : 'false'}>
          <span data-testid="home-status">
            {lights.on > 0
              ? t('dashboard.home.lightsOn', { count: lights.on })
              : t('dashboard.home.allCalm')}
          </span>
        </p>
      ) : (
        <p data-testid="home-empty" className="m-0">
          {t('dashboard.home.empty')}
        </p>
      )}
    </div>
  );
}
